import { CommandBar, CommandBarLink, CommandBarContainer } from 'components/layout/CommandBar';
import { PageHeader } from 'components/layout/PageHeader';
import { usePermissions, UserPermission, WriteOn } from 'modules/permissions';
import { useTranslation } from 'react-i18next';

interface IssueListHeaderProps {
   toggleFilterBar: () => void;
}

export const IssuesListHeader = ({ toggleFilterBar }: IssueListHeaderProps) => {
   const { hasPermission } = usePermissions();

   const items = () => {
      return hasPermission(WriteOn(UserPermission.NewObservation))
         ? [
              {
                 key: 'newObservation',
                 text: 'Report a new Observation',
                 data: {
                    link: '/observation/new'
                 },
                 iconProps: { iconName: 'Add' },
                 commandBarButtonAs: CommandBarLink
              }
           ]
         : [];
   };

   return (
      <>
         <PageHeader>Issue List - Overview</PageHeader>

         <CommandBarContainer>
            <CommandBar
               items={items()}
               farItems={[
                  {
                     key: 'filter',
                     text: "Filter",
                     cacheKey: 'filter',
                     iconProps: { iconName: 'Filter' },
                     iconOnly: true,
                     onClick: toggleFilterBar
                  }
               ]}
            />
         </CommandBarContainer>
      </>
   );
};
